import React from "react";

export default function ThankYou() {
  return (
    <div
      style={{
        background: "#fefae0",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "2rem",
        textAlign: "center"
      }}
    >
      <h1 className="text-5xl font-bold mb-4 text-green-700">
        🎉 Thank You for Booking! 🎉
      </h1>
      <p className="text-lg mb-2">
        We’ve received your booking and will get back to you shortly.
      </p>
      <p className="mb-6 text-gray-700">
        📞 Contact: <strong>7717776192</strong>  
        <br />
        💬{" "}
        <a
          href="https://wa.me/917717776192"
          target="_blank"
          rel="noopener noreferrer"
          className="text-green-600 underline"
        >
          Chat with us on WhatsApp
        </a>
      </p>
      <blockquote className="italic text-gray-500">
        “Life is short, and the world is wide — let’s make your trip the best
        story you’ll tell… with comfy seats and zero back pain!”
      </blockquote>
    </div>
  );
}
